import '../custom/custom_cross_dimensions.js.coffee';# Added by Script 
import '../chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.CustomHeatmapChart extends Monitoring.Views.Charts.CustomCrossDimensionsChart
  url: '/monitoring/api/charts/custom_heatmap'

  chartOptions: ->
    @showPercentage = !!@_settings.showPercentage
    @showValue = !!@_settings.showValue

    matrix = @_buildMatrix()

    offset = Math.trunc(matrix.yAxisCategories.length / 12) + 1
    @$el.attr('data-height', offset)

    events = {
      mouseOver: @cellMouseIn,
      mouseOut: @cellMouseOut,
    }

    highchartSeries = [
      {
        borderWidth: 0,
        dataLabels: { enabled: true, color: '#000000' },
        point: { events: events },
        data: matrix.highcharts_data,
        turboThreshold: Number.MAX_VALUE
      }
    ]

    xCategoriesNamesLengths = matrix.xAxisCategories.map (element) -> element.length
    longestCategoryNameLength = _.max(xCategoriesNamesLengths)
    totalXAxisLabelsWidth = 0.85 * @$el.find('.chart')[0].offsetWidth
    eachCategoryMaxPossibleWidth = totalXAxisLabelsWidth / matrix.xAxisCategories.length
    eachCategoryMaxPossibleLength =  eachCategoryMaxPossibleWidth / 8

    if longestCategoryNameLength > eachCategoryMaxPossibleLength
      marginBottom = Math.max(70, 5 * longestCategoryNameLength)
    else
      marginBottom = 70

    options = {
      chart:
        renderTo: @$el.find('.chart')[0]
        type: 'heatmap'
        marginTop: 35
        height: 300 * offset
      title:
        text: null
      legend:
        align: 'right'
        verticalAlign: 'top'
        x: 0
        y: 40
        floating: false
        layout: "vertical"
      xAxis:
        categories: matrix.xAxisCategories
        title: null
      yAxis:
        categories: matrix.yAxisCategories
        title: null
        labels:
          step: 1
      colorAxis:
        min: 0
        minColor: '#FFFFFF'
        maxColor: '#FF9800'
      tooltip:
        followPointer: true
        positioner: (labelWidth, labelHeight, point) ->
          chart = this.chart
          pointX = if (point.plotX + labelWidth > chart.plotWidth) then point.plotX + chart.plotLeft - labelWidth - 10 else point.plotX + chart.plotLeft + 10
          x = if pointX > 0 then pointX else 0
          y = if point.plotY + chart.plotTop - 20 > 35 then point.plotY + chart.plotTop - 20 else 35
          return { x: x , y: y }
        formatter: @_tooltipFormatter
      plotOptions:
        heatmap:
          cursor: 'pointer'
          states:
            hover:
              enabled: false
          dataLabels:
            style:
              color: '#35444C'
              fontWeight: 'normal'
      isHierarchical: false
      isBarHierarchyNavigation: false
      isHeatmap: true
      series: highchartSeries
    }
    options

  _buildMatrix: () ->
    outer_key_indices = {}
    inner_key_indices = {}
    highcharts_data = []

    current_outer_key_index = 0
    current_inner_key_index = 0

    for outer_data in @data.series
      if !(outer_data.name of outer_key_indices)
        outer_key_indices[outer_data.name] = current_outer_key_index
        current_outer_key_index += 1

      for inner_data in outer_data.data
        if !(inner_data.name of inner_key_indices)
          inner_key_indices[inner_data.name] = current_inner_key_index
          current_inner_key_index += 1

        data_element = [
          outer_key_indices[outer_data.name],
          inner_key_indices[inner_data.name],
          inner_data.y
        ]

        highcharts_data.push(data_element)

    {
      xAxisCategories: Object.keys(outer_key_indices),
      yAxisCategories: Object.keys(inner_key_indices),
      highcharts_data: highcharts_data
    }

  _tooltipFormatter: () ->
    if @key
      "<b>#{@point.original_name}</b><br/>: #{@point.y} (#{Math.round(@percentage * 10) / 10}%)"
    else
      false

  cellMouseIn: (event) =>
    @_destroySelectionHighlight()
    xIndex = event.target.x
    yIndex = @chart.yAxis[0].categories.length
    x0 = @chart.xAxis[0].toPixels(xIndex)
    x1 = @chart.xAxis[0].toPixels(xIndex + 1)
    width = x1 - x0
    y0 = @chart.yAxis[0].toPixels(yIndex)
    y1 = @chart.yAxis[0].toPixels(0)
    height = y1 - y0
    x0 = x0 - (width / 2)
    y0 = y0 + ((height / 2) / yIndex)
    attributes = { 'stroke-width': 3, stroke: 'rgb(226,144,23)', zIndex: 3 }
    @selectionHighlight = @chart.renderer.rect(x0, y0, width, height).attr(attributes).add()

  cellMouseOut: (event) =>
    @_destroySelectionHighlight()

  _destroySelectionHighlight: ->
    return unless @selectionHighlight
    @selectionHighlight.destroy()
    @selectionHighlight = undefined
